var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsertDriveFile24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2.00016L15 2.00082L20.9995 8.00131L20.9985 20.0013C20.9984 21.1013 20.0984 22.0012 18.9984 22.0011L6.98836 22.0002C5.88836 22.0001 4.99843 21.1 4.99852 20L5.00984 4C5.00993 2.9 5.9 2.00007 7 2.00016ZM6.99984 4.00016L6.99852 20.0002L18.9985 20.0011L18.9994 9.00115L13.9994 9.00074L13.9998 4.00074L6.99984 4.00016Z",
    fill: "#0d4073"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertDriveFile24Px);
export default __webpack_public_path__ + "static/media/insert_drive_file_24px.db0b535e91127e2758be85f98a0d21af.svg";
export { ForwardRef as ReactComponent };